// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "style." + {"475":"f7f99ba9480638afdf59","988":"a6b1fa100ff476c387a8"}[chunkId] + ".css";
};